<script lang="ts">
import Box from "./Box.svelte"
</script>
<main>
	<h1>SAKI KOMIKADO</h1>
	<div id="bib">
		<p>2008 - 2015: Osaka University (M.Eng.)</p>
		<p>2017 - 2021: teamLab</p>
	</div>
	<div id='works'>
		<Box title={"metriko"}
			 subtitle={"(2025) c++ header only parameterization and meshing library"}
			 link={"https://github.com/komietty/metriko/"}
			 src={"imgs/gargoyle.jpg"}
			 islink={false}
			 />
		<Box title={"unity-vectorfield"}
			 subtitle={"(2023) discrete differential geometry library for unity"}
			 link={"https://github.com/komietty/unity-vectorfield/"}
			 src={"imgs/vectorfield.jpg"}
			 islink={false}
			 />
		<Box title={"Catching and Collecting Forest"}
			 subtitle={"(2020) as the lead programmer"}
			 link={"https://www.teamlab.art/ew/collecting_forest/forest/"}
			 src={"https://www.youtube.com/embed/DQcE8cUQJaw?showinfo=0"}
			 islink={true}
			 />
		<Box title={"Catching and Collecting Flutter of Butterflies"}
			 subtitle={"(2021) as the lead programmer"}
			 link={"https://www.teamlab.art/w/collecting_butterflies/"}
			 src={"https://www.youtube.com/embed/PaaycGEsaII"}
			 islink={true}
			 />
		<Box title={"The Columns, Moving Creates Vortices and Vortices Create ..."}
			 subtitle={"(2019) as the vortex simulation programmer"}
			 link={"https://borderless.teamlab.art/ew/vortices_shanghai/?autoplay=true#:~:text=When%20a%20person%20moves%2C%20a,around%20it%2C%20creating%20a%20vortex."}
			 src={"https://www.youtube.com/embed/YN4t2aEQvFk"}
			 islink={true}
			 />
		<Box title={"Life Survives by the Power of Life II"}
			 subtitle={"(2020) as the byobu programmer"}
			 link={"https://www.teamlab.art/jp/w/lifesurvives/"}
			 src={"https://www.youtube.com/embed/xujFwRHzUKI"}
			 islink={true}
			 />
		<Box title={"Centrair: Fly with 787 dreamliner"}
			 subtitle={"(2018) as the lead programmer"}
			 link={"https://futurepark.teamlab.art/en/playinstallations/fly787dreamliner/"}
			 src={"https://www.youtube.com/embed/PGwvTwJtk5Q"}
			 islink={true}
			 />
		<Box title={"Walk, Walk, Walk: Search, Deviate, Reunion"}
			 subtitle={"(2018) as the charactor motion programmer"}
			 link={"https://www.teamlab.art/e/walk-walk-walk/"}
			 src={"https://www.youtube-nocookie.com/embed/1YUuk95cDcI?showinfo=0"}
			 islink={true}
			 />
		<Box title={"Hyoen 2019"}
			 subtitle={"(2019) as the lead programmer, live performance project"}
			 link={"https://www.team-lab.com/hyoen2019/"}
			 src={"imgs/hyoen2019.jpg"}
			 islink={false}
			 />
		<Box title={"unity-nurbs"}
			 subtitle={"(2021) NURBS spline/surface library for unity"}
			 link={"https://github.com/komietty/unity-nurbs/"}
			 src={"imgs/nurbs.png"}
			 islink={false}
			 />
		<Box title={"Kodokuno-chizu"}
			 subtitle={"(2018) exhibition @yotsuya-mikakunin-studio"}
			 link={"https://www.instagram.com/p/BrDZ3MEjWyd/"}
			 src={"imgs/deformation.png"}
			 islink={false}
			 />
		<Box title={"SkinMeshRenderer"}
			 subtitle={"(2020) exhibition @kannai-bunko"}
			 link={"http://kannaibunko.com/event/859"}
			 src={"imgs/smr_sumnail.png"}
			 islink={false}
			 />
		<Box title={"UnityGraphicsProgramming"}
			 subtitle={"(~2020) a techbook for graphics programming on Unity3d"}
			 link={"https://indievisuallab.github.io/"}
			 src={"imgs/ugp_mini.png"}
			 islink={false}
			 />
	</div>

	<div id='footer'>
		<p>
			<span>structure and visuals.</span>
			<span>&ensp</span>
			<a href='https://twitter.com/komietty' target="_blank">Twitter</a>
			<span>&ensp</span>
			<a href='https://github.com/komietty' target="_blank">Github</a>
		</p>
	</div>
</main>

<style type="text/scss">
$w: 1150px;
main {
	h1 {
		text-transform: uppercase;
		font-size: 2em;
		font-weight: 150;
		max-width: $w;
		padding-top: 100px;
		padding-bottom: 100px;
		margin: 0 auto;
	}
	#bib {
		font-size: 1.15em;
		font-weight: 150;
		max-width: $w;
		padding-bottom: 80px;
		margin: 0 auto;
		p {
			padding: 0;
			margin: 10px 0;
		}
	}
	#works {
		max-width: $w;
		margin: 0 auto;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	#footer {
		max-width: $w;
		margin: 0 auto;
		padding-top: 100px;
		padding-bottom: 100px;
		a, span, p { color: #aaa; }
		p { text-align: center; }
		a { text-decoration: underline; &:hover { color: #000; } }
	}
}
</style>